import { z } from "zod";

export const VT_CONSULTATION_ARTISANS = [
  "grutier",
  "couvreur",
  "macon",
  "terrassier",
  "climaticien",
  "plombier",
  "etudeDeSol",
  "technopieux",
  "autres",
] as const;
export type VtConsultationArtisan = (typeof VT_CONSULTATION_ARTISANS)[number];

export const VT_CONSULTATION_ARTISAN_LABELS: Record<VtConsultationArtisan, string> = {
  grutier: "Grutier",
  couvreur: "Couvreur",
  macon: "Maçon",
  terrassier: "Terrassier",
  climaticien: "Climaticien",
  plombier: "Plombier",
  etudeDeSol: "Étude de sol",
  technopieux: "Technopieux",
  autres: "Autres",
};

export const vtArtisanSchema = z
  .object({
    consultationArtisans: z.array(z.enum(VT_CONSULTATION_ARTISANS)).optional(),
    consultationArtisansAutresDetail: z.string().optional(),
  })
  .partial();

export type VtArtisan = z.infer<typeof vtArtisanSchema>;
